import {TopicModel} from '../../models/api/topicModel';
import {buildPublicId} from '../../models/applications/publicIdTypes';

/*
 * Computed properties.
 */

export function buildTopicPublicId(topic: TopicModel) {
  return buildPublicId('topic', topic.id);
}

export function buildTopicPublicLink(host: string, topic: TopicModel) {
  return `${host}/open/${buildTopicPublicId(topic)}`;
}

export function parseApplicationUidFromType(topic: TopicModel) {
  if (!topic.type.startsWith('app_')) {
    return undefined;
  }
  return topic.type.split('app_')?.[1];
}
